/**
 * Возвращает смещение часового пояса браузера в формате "+03:00".
 * @returns {string} Смещение UTC.
 */
export const getBrowserTimeshift = () => {
  const minutes = -1 * new Date().getTimezoneOffset();
  const h = String(Math.floor(minutes / 60));
  const m = String(minutes % 60);
  const sign = minutes < 0 ? "\x2d" : "\x2b";
  return `${sign}${h?.padStart(2, "0") || "00"}:${
    m?.padStart(2, "0") || "00"
  }`;
};

/**
 * Находит атрибут timeZone из массива атрибутов.
 * @param {Array<{group: string, name: string}>} attrs - Массив атрибутов.
 * @returns {object|undefined} Найденный атрибут или undefined.
 */
export const findTimeZoneAttr = (attrs) => attrs?.find(({ group, name }) => group === 'general' && name === 'timeZone');

/**
 * Конвертирует строку смещения UTC в миллисекунды.
 * @param {string} timeZone - Смещение UTC (например "+03:00").
 * @returns {number} Смещение в миллисекундах.
 */
export const getUtcOffsetMs = (timeZone) => {
  if (!timeZone) return 0;
  const sign = timeZone.startsWith('-') ? -1 : 1;
  const [hoursStr, minutesStr = '0'] = timeZone.replace(/[+-]/, '').split(':');
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return 0;
  return sign * (hours * 60 + minutes) * 60 * 1000;
};
